(function () {
  'use strict';

  const TRANSITION_DURATION = 350;
  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const supportsHas = CSS.supports('selector(:has(*))');

  // ── SVG icon markup (matches snippets/icon.liquid output) ──
  const ICON_CHEVRON = '<span class="icon icon-new icon-chevron menu-icon"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2"/></svg></span>';

  document.addEventListener('DOMContentLoaded', function initDrawerNav() {
    const drawerMenu = document.querySelector('[data-dnav]');
    if (!drawerMenu) return;

    const menuContents = drawerMenu.querySelector('.dnav-contents');
    const mainContainer = drawerMenu.querySelector('[data-dnav-main]');
    const mainBackBtn = drawerMenu.querySelector('.dnav-header__back');
    const navStack = [];
    const exitTimers = new WeakMap();
    let focusTrapCleanup = null;
    const panel = drawerMenu.querySelector('.dnav-panel');

    // ── Hamburger button — we control open/close, not theme.js ──
    const menuButton = document.querySelector('.header__icon-menu');
    let isOpen = false;

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      drawerMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (!supportsHas) document.body.classList.add('dnav-root-open');
      if (menuButton) {
        menuButton.setAttribute('aria-expanded', 'true');
      }
      setTimeout(function () {
        drawerMenu.classList.add('visible');
      }, 16);

      // GA4 tracking
      maxDepthReached = 0;
      searchFocusTracked = false;
      trackNav('nav_drawer_open', { trigger_method: 'hamburger' });
    }

    function closeDrawer(trigger) {
      if (!isOpen) return;
      isOpen = false;
      lastCloseTrigger = trigger || 'unknown';
      drawerMenu.classList.remove('visible');
      if (menuButton) {
        menuButton.setAttribute('aria-expanded', 'false');
      }

      // GA4 tracking
      trackNav('nav_drawer_close', {
        trigger_method: lastCloseTrigger,
        max_depth_reached: maxDepthReached
      });
      lastCloseTrigger = 'unknown';

      setTimeout(function () {
        drawerMenu.classList.remove('active');
        document.body.style.overflow = '';
        if (!supportsHas) document.body.classList.remove('dnav-root-open');
        resetAll();
      }, TRANSITION_DURATION);
    }

    // Hamburger button toggles drawer
    if (menuButton) {
      menuButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen) {
          closeDrawer('hamburger');
        } else {
          openDrawer();
        }
      });
    }

    // Escape key closes drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeDrawer('escape');
      }
    });

    // ── GA4 dataLayer tracking ──
    let maxDepthReached = 0;
    let searchFocusTracked = false;
    var lastCloseTrigger = 'unknown';

    function trackNav(eventName, params) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...params });
    }

    function getMenuLevel(depth) {
      return 'L' + depth;
    }

    function getItemPosition(el) {
      var listItem = el.closest('[data-list-item]');
      if (!listItem) return 0;
      var siblings = listItem.parentElement.querySelectorAll(':scope > [data-list-item]');
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] === listItem) return i + 1;
      }
      return 0;
    }

    function humanizeHandle(handle) {
      if (!handle) return '';
      return handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }

    function getGaTitle(el) {
      var handle = el.getAttribute('data-ga-title');
      var itemHandle = el.getAttribute('data-ga-item');
      var parentSubmenu = el.closest('.dnav-list--sub');
      var parentGaTitle = parentSubmenu ? parentSubmenu.getAttribute('data-ga-title') : null;

      // If this item's ga-title matches its parent submenu, it shares a collection — use item handle
      if (handle && parentGaTitle && handle === parentGaTitle && itemHandle) {
        return humanizeHandle(itemHandle);
      }

      if (handle) return humanizeHandle(handle);
      if (itemHandle) return humanizeHandle(itemHandle);
      var text = el.querySelector('.menu-link-text');
      return text ? text.textContent.trim() : el.textContent.trim();
    }

    function getSubmenuHeading(submenuEl) {
      if (!submenuEl) return '';
      var gaName = submenuEl.getAttribute('data-ga-name');
      if (gaName) return gaName;
      var gaTitle = submenuEl.getAttribute('data-ga-title');
      if (gaTitle) return humanizeHandle(gaTitle);
      var heading = submenuEl.querySelector('.dnav-submenu-title__text');
      return heading ? heading.textContent.trim() : '';
    }

    function getDepthFromSubmenu(submenuEl) {
      if (!submenuEl) return 0;
      return parseInt(submenuEl.getAttribute('data-depth'), 10) || 0;
    }

    function getBreadcrumbs(submenuEl) {
      var crumbs = {};
      var el = submenuEl;
      while (el) {
        var d = parseInt(el.getAttribute('data-depth'), 10);
        if (!isNaN(d) && d >= 1) {
          crumbs['parent_l' + d] = getSubmenuHeading(el);
        }
        el = el.parentElement ? el.parentElement.closest('.dnav-list--sub') : null;
      }
      return crumbs;
    }

    // --- :has() fallback: toggle classes for browsers without :has() support ---
    function updateHasFallback() {
      if (supportsHas) return;
      var hasActiveSubmenu = navStack.length > 0;
      if (panel) {
        panel.classList.toggle('dnav-panel--submenu-active', hasActiveSubmenu);
      }
    }

    // --- Focus trap for open submenus ---
    function trapFocus(container) {
      function handleKeydown(e) {
        if (e.key !== 'Tab') return;

        const focusable = [...container.querySelectorAll(FOCUSABLE_SELECTOR)]
          .filter(function (el) { return el.offsetParent !== null; });
        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable.at(-1);

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      container.addEventListener('keydown', handleKeydown);
      return function removeTrap() {
        container.removeEventListener('keydown', handleKeydown);
      };
    }

    // ── Deferred submenu rendering ──
    var menuDataCache = null;

    function getMenuData() {
      if (menuDataCache) return menuDataCache;
      var script = document.getElementById('dnav-menu-data');
      if (!script) return null;
      try {
        menuDataCache = JSON.parse(script.textContent);
      } catch (err) {
        return null;
      }
      return menuDataCache;
    }

    function findSubmenuData(submenus, targetId) {
      if (!submenus) return null;
      for (var i = 0; i < submenus.length; i++) {
        var sub = submenus[i];
        if (sub.id === targetId) return sub;
        if (sub.submenus && sub.submenus.length > 0) {
          var found = findSubmenuData(sub.submenus, targetId);
          if (found) return found;
        }
      }
      return null;
    }

    function escAttr(str) {
      if (!str) return '';
      return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function buildSubmenuFromData(submenuId) {
      var data = getMenuData();
      if (!data) return null;
      var submenuData = findSubmenuData(data, submenuId);
      if (!submenuData) return null;

      // Build the <li class="dnav-submenu-container"> wrapper
      var container = document.createElement('li');
      container.className = 'dnav-submenu-container';
      container.setAttribute('data-dnav-dynamic', 'true');

      // Build the <ul class="dnav-list dnav-list--sub">
      var ul = document.createElement('ul');
      ul.className = 'dnav-list dnav-list--sub';
      ul.id = submenuData.id;
      ul.setAttribute('data-depth', submenuData.depth);
      ul.setAttribute('data-parent-id', submenuData.parentId);
      ul.setAttribute('data-ga-title', submenuData.gaTitle);
      ul.setAttribute('data-ga-name', submenuData.gaName);
      ul.setAttribute('aria-hidden', 'true');

      var html = '';

      // Heading <li> — title row only (header bar is shared at .dnav-header level)
      html += '<li class="dnav-item dnav-item--heading dnav-submenu-heading">';
      html += '<div class="dnav-submenu-title">';
      html += '<h3 class="dnav-submenu-title__text fs-body-300 font-mont">' + escAttr(submenuData.title) + '</h3>';
      html += '<a href="' + escAttr(submenuData.url) + '" class="dnav-submenu-title__shopall font-mont" data-dnav-item="link">Shop All</a>';
      html += '</div>';
      html += '</li>';

      // Child <li> items
      if (submenuData.children) {
        for (var i = 0; i < submenuData.children.length; i++) {
          var child = submenuData.children[i];
          html += '<li class="dnav-item font-mont" data-list-item>';
          html += '<a';
          html += ' data-dnav-item="' + (child.hasChildren ? 'parent' : 'link') + '"';
          html += ' class="dnav-link' + (child.hasChildren ? ' no-transition' : '') + (child.isBrandLogo ? ' dnav-link--has-logo' : '') + '"';
          html += ' href="' + escAttr(child.url) + '"';
          if (child.hasChildren) {
            html += ' data-submenu-target="' + escAttr(child.submenuId) + '"';
            html += ' aria-haspopup="true" aria-expanded="false"';
          }
          html += ' data-ga-title="' + escAttr(child.gaHandle) + '"';
          html += ' data-ga-item="' + escAttr(child.handle) + '"';
          html += '>';
          if (child.isBrandLogo && child.imageUrl) {
            html += '<img class="dnav-brand-logo" src="' + escAttr(child.imageUrl) + '" alt="" width="40" height="40" loading="lazy">';
          }
          html += '<span class="menu-link-text">' + escAttr(child.title) + '</span>';
          if (child.hasChildren) {
            html += ICON_CHEVRON;
          }
          html += '</a>';
          html += '</li>';
        }
      }

      // Promo banner
      if (submenuData.promo) {
        var p = submenuData.promo;
        html += '<li class="dnav-item dnav-promo-item" data-list-item>';
        html += '<a href="' + escAttr(p.link) + '" class="dnav-promo-banner">';
        html += '<img class="dnav-promo-banner__img" src="' + escAttr(p.imageUrl) + '" alt="' + escAttr(p.alt) + '" width="400" height="125" loading="lazy">';
        if (p.promoText || p.ctaText) {
          html += '<div class="dnav-promo-banner__overlay">';
          if (p.promoText) {
            html += '<span class="dnav-promo-banner__text font-mont">' + escAttr(p.promoText) + '</span>';
          }
          if (p.ctaText) {
            html += '<span class="dnav-promo-banner__cta font-mont">' + escAttr(p.ctaText) + '</span>';
          }
          html += '</div>';
        }
        html += '</a>';
        html += '</li>';
      }

      ul.innerHTML = html;
      container.appendChild(ul);

      // Insert into the correct parent list
      var parentList;
      if (submenuData.parentId === 'primary') {
        parentList = drawerMenu.querySelector('.dnav-primary-links');
      } else {
        parentList = document.getElementById(submenuData.parentId);
      }
      if (parentList) {
        parentList.appendChild(container);
      }

      return ul;
    }

    // --- pushPanel: slide a submenu on-screen ---
    function pushPanel(submenuEl) {
      clearTimeout(exitTimers.get(submenuEl));
      exitTimers.delete(submenuEl);

      submenuEl.classList.remove('is-exiting');
      submenuEl.classList.add('is-active');
      submenuEl.setAttribute('aria-hidden', 'false');
      navStack.push(submenuEl);
      menuContents.scrollTo(0, 0);

      // Show the shared back button in the main header
      if (mainBackBtn) mainBackBtn.hidden = false;

      // Trap focus on mainContainer so both header (back/search/close) and submenu items are reachable
      if (focusTrapCleanup) focusTrapCleanup();
      focusTrapCleanup = trapFocus(mainContainer);
      updateHasFallback();
    }

    // --- popPanel: slide the top submenu off-screen ---
    function popPanel() {
      const panel = navStack.pop();
      if (!panel) return null;

      if (focusTrapCleanup) {
        focusTrapCleanup();
        focusTrapCleanup = null;
      }

      panel.classList.remove('is-active');
      panel.classList.add('is-exiting');
      panel.setAttribute('aria-hidden', 'true');

      clearTimeout(exitTimers.get(panel));
      const timerId = setTimeout(function clearExitClass() {
        panel.classList.remove('is-exiting');
        exitTimers.delete(panel);
      }, TRANSITION_DURATION);
      exitTimers.set(panel, timerId);

      menuContents.scrollTo(0, 0);

      // Hide back button if we're back at root level
      if (navStack.length === 0 && mainBackBtn) {
        mainBackBtn.hidden = true;
      }

      if (navStack.length > 0) {
        focusTrapCleanup = trapFocus(mainContainer);
      }

      updateHasFallback();
      return panel;
    }

    // --- resetAll: clear all panels and stack, remove dynamic submenus ---
    function resetAll() {
      if (focusTrapCleanup) {
        focusTrapCleanup();
        focusTrapCleanup = null;
      }

      navStack.length = 0;

      // Hide the shared back button
      if (mainBackBtn) mainBackBtn.hidden = true;

      // Remove dynamically-created submenus to free memory
      drawerMenu.querySelectorAll('[data-dnav-dynamic]').forEach(function (el) {
        el.remove();
      });

      // Reset any server-rendered submenu state (unlikely but safe)
      drawerMenu.querySelectorAll('.dnav-list--sub').forEach(function (sub) {
        sub.classList.remove('is-active', 'is-exiting');
        sub.setAttribute('aria-hidden', 'true');
      });

      drawerMenu.querySelectorAll('[data-submenu-target]').forEach(function (link) {
        link.setAttribute('aria-expanded', 'false');
      });

      updateHasFallback();
    }

    // --- clickParent: open submenu (with deferred rendering) ---
    function handleParentClick(e) {
      const target = e.target.closest('[data-dnav-item="parent"]');
      if (!target) return;
      const submenuId = target.getAttribute('data-submenu-target');
      if (!submenuId) return;

      e.preventDefault();
      e.stopPropagation();

      target.setAttribute('aria-expanded', 'true');

      // Deferred rendering: build submenu on first access if not in DOM
      var childMenu = document.getElementById(submenuId);
      if (!childMenu) {
        childMenu = buildSubmenuFromData(submenuId);
      }
      if (!childMenu) return;

      var depth = getDepthFromSubmenu(childMenu);
      maxDepthReached = Math.max(maxDepthReached, depth);
      var menuItemName = getGaTitle(target);

      var parentOfChild = childMenu.parentElement ? childMenu.parentElement.closest('.dnav-list--sub') : null;
      var crumbs = parentOfChild ? getBreadcrumbs(parentOfChild) : {};
      trackNav('nav_menu_click', {
        menu_item: menuItemName,
        menu_level: getMenuLevel(depth),
        menu_position: getItemPosition(target),
        link_url: target.getAttribute('href') || '',
        ...crumbs
      });

      pushPanel(childMenu);

      // Focus the shared back button in the main header
      if (mainBackBtn) mainBackBtn.focus({ preventScroll: true });
    }

    // --- clickBack: close current submenu (back button is in shared header, not inside submenu) ---
    function handleBackClick(e) {
      const target = e.target.closest('[data-dnav-item="back"]');
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();

      // Back button is in the shared header — get current submenu from navStack
      const currentSubmenu = navStack.at(-1);
      if (!currentSubmenu) return;

      trackNav('nav_back_click', {
        from_menu: getSubmenuHeading(currentSubmenu),
        from_level: getMenuLevel(getDepthFromSubmenu(currentSubmenu))
      });

      const parentLink = drawerMenu.querySelector(
        '[data-submenu-target="' + CSS.escape(currentSubmenu.id) + '"]'
      );
      if (parentLink) {
        parentLink.setAttribute('aria-expanded', 'false');
      }

      popPanel();

      if (parentLink) parentLink.focus();
    }

    drawerMenu.addEventListener('click', handleParentClick, true);
    drawerMenu.addEventListener('click', handleBackClick, true);

    // Overlay click closes the drawer
    var overlayEl = drawerMenu.querySelector('[data-dnav-overlay]');
    if (overlayEl) {
      overlayEl.addEventListener('click', function () {
        closeDrawer('overlay');
      });
    }

    // Close button — dismiss autocomplete first, then close drawer
    drawerMenu.addEventListener('click', function handleCloseClick(e) {
      const closeBtn = e.target.closest('[data-dnav-close]');
      if (!closeBtn) return;

      const header = closeBtn.closest('.dnav-header');
      const scope = header || drawerMenu;

      const nostoAutocomplete = scope.querySelector('.ns-autocomplete');
      const nostoInner = scope.querySelector('.ns-autocomplete__inner');
      const isAutocompleteVisible = (nostoAutocomplete &&
        nostoAutocomplete.offsetParent !== null &&
        nostoAutocomplete.style.display !== 'none') ||
        (nostoInner && nostoInner.offsetParent !== null);

      if (isAutocompleteVisible) {
        const searchInput = scope.querySelector('.dnav-header__input');
        if (searchInput) {
          searchInput.value = '';
          searchInput.blur();
          searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        return;
      }

      closeDrawer('close_button');
    });

    // ── GA4 tracking: delegated click listeners ──

    // Track regular link clicks
    drawerMenu.addEventListener('click', function handleLinkTrack(e) {
      var link = e.target.closest('[data-dnav-item="link"]');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var isNavigating = href && href !== '#';

      // Prevent immediate navigation so the GA4 event has time to flush
      if (isNavigating) {
        e.preventDefault();
      }

      if (link.classList.contains('dnav-submenu-title__shopall')) {
        var submenu = link.closest('.dnav-list--sub');
        var crumbs = submenu ? getBreadcrumbs(submenu) : {};
        trackNav('nav_shopall_click', {
          menu_item: getSubmenuHeading(submenu),
          menu_level: getMenuLevel(getDepthFromSubmenu(submenu)),
          link_url: href,
          ...crumbs
        });
      } else {
        var parentSubmenu = link.closest('.dnav-list--sub');
        var depth = parentSubmenu ? getDepthFromSubmenu(parentSubmenu) + 1 : 0;
        var linkItemName = getGaTitle(link);
        var crumbs = parentSubmenu ? getBreadcrumbs(parentSubmenu) : {};
        trackNav('nav_link_click', {
          menu_item: linkItemName,
          menu_level: getMenuLevel(depth),
          menu_position: getItemPosition(link),
          link_url: href,
          parent_item: parentSubmenu ? getSubmenuHeading(parentSubmenu) : 'Main Menu',
          ...crumbs
        });
      }

      // Brief delay to let GA4 process the dataLayer event before navigating
      if (isNavigating) {
        setTimeout(function () { window.location.href = href; }, 100);
      }
    });

    // Track auth row clicks
    drawerMenu.addEventListener('click', function handleAuthTrack(e) {
      var authBtn = e.target.closest('.dnav-auth-row__btn');
      if (!authBtn) return;
      var btnText = authBtn.textContent.trim().toLowerCase();
      trackNav('nav_auth_click', {
        auth_action: btnText.indexOf('reward') !== -1 ? 'my_rewards' : 'sign_in',
        is_logged_in: btnText.indexOf('reward') !== -1
      });
    });

    // Live Chat — close drawer so chat widget is visible
    drawerMenu.addEventListener('click', function handleLiveChat(e) {
      var chatBtn = e.target.closest('.lchtbtn');
      if (!chatBtn) return;
      closeDrawer('live_chat');
    });

    // Track bottom menu clicks
    drawerMenu.addEventListener('click', function handleBottomTrack(e) {
      var bottomLink = e.target.closest('.dnav-bottom-menu__link');
      if (!bottomLink) return;
      trackNav('nav_bottom_click', {
        menu_item: bottomLink.textContent.trim(),
        link_url: bottomLink.getAttribute('href') || ''
      });
    });

    // Track promo banner clicks
    drawerMenu.addEventListener('click', function handlePromoTrack(e) {
      var promo = e.target.closest('.dnav-promo-banner');
      if (!promo) return;

      var href = promo.getAttribute('href') || '';
      var isNavigating = href && href !== '#';

      if (isNavigating) {
        e.preventDefault();
      }

      var submenu = promo.closest('.dnav-list--sub');
      var promoText = promo.querySelector('.dnav-promo-banner__text');
      var crumbs = submenu ? getBreadcrumbs(submenu) : {};
      trackNav('nav_promo_click', {
        menu_item: getSubmenuHeading(submenu),
        promo_text: promoText ? promoText.textContent.trim() : '',
        promo_url: href,
        menu_level: getMenuLevel(getDepthFromSubmenu(submenu)),
        ...crumbs
      });

      if (isNavigating) {
        setTimeout(function () { window.location.href = href; }, 100);
      }
    });

    // Track search form submissions (single shared search form in main header)
    drawerMenu.addEventListener('submit', function handleSearchSubmit(e) {
      var form = e.target.closest('.dnav-header__search');
      if (!form) return;
      var input = form.querySelector('.dnav-header__input');
      var term = input ? input.value.trim() : '';
      trackNav('nav_search_submit', {
        search_term: term,
        search_location: 'main'
      });
    });

    // Track search input focus (once per drawer open)
    drawerMenu.addEventListener('focusin', function handleSearchFocus(e) {
      if (!e.target.matches('.dnav-header__input')) return;
      if (searchFocusTracked) return;
      searchFocusTracked = true;
      trackNav('nav_search_focus', {
        search_location: 'main'
      });
    });

    // Keyboard support for back buttons
    drawerMenu.addEventListener('keydown', function handleBackKeydown(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const target = e.target.closest('[data-dnav-item="back"]');
      if (!target) return;

      e.preventDefault();
      target.click();
    });
  });
})();
